import { notification } from '@pu/mpp-ui/notifications';
import type { TDeleteMaintenanceParams } from 'core/model/interfaces/maintenance';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IMaintenanceState } from '../types';

export const deleteMaintenance = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/deleteMaintenance`,
  async (params: TDeleteMaintenanceParams) => {
    try {
      await apiService.maintenance.deleteMaintenance(params);

      notification.success('La pantalla de mantenimiento se eliminó correctamente.');

      return params.id;
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Error inesperado al eliminar el mantenimiento.');

      showNotificationError(errorMessage);

      throw error;
    }
  },
);

export const deleteMaintenanceReducer: TSliceExtraReducer<IMaintenanceState> = builder =>
  builder
    .addCase(deleteMaintenance.pending, state => {
      state.modal.loading = true;
      state.modal.success = false;
    })
    .addCase(deleteMaintenance.rejected, state => {
      state.modal.loading = false;
      state.modal.success = false;
    })
    .addCase(deleteMaintenance.fulfilled, state => {
      state.modal.loading = false;
      state.modal.success = true;
    });
